import type { CSSProperties } from "react";

import type { PictureAsset } from "@/lib/images";
import { cn } from "@/lib/utils";

type ResponsiveImageProps = {
  image: PictureAsset;
  alt: string;
  sizes: string;
  imgClassName?: string;
  pictureClassName?: string;
  style?: CSSProperties;
  priority?: boolean;
  loading?: "eager" | "lazy";
};

export function ResponsiveImage({
  image,
  alt,
  sizes,
  imgClassName,
  pictureClassName,
  style,
  priority = false,
  loading,
}: ResponsiveImageProps) {
  const resolvedLoading = loading ?? (priority ? "eager" : "lazy");

  return (
    <picture className={cn("block", pictureClassName)}>
      <source type="image/avif" srcSet={image.avif} sizes={sizes} />
      <source type="image/webp" srcSet={image.webp} sizes={sizes} />
      <img
        src={image.src}
        srcSet={image.fallback}
        sizes={sizes}
        alt={alt}
        width={image.width}
        height={image.height}
        loading={resolvedLoading}
        decoding={priority ? "auto" : "async"}
        {...(priority ? { fetchPriority: "high" as const } : {})}
        className={imgClassName}
        style={style}
      />
    </picture>
  );
}
